/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-05 15:23:25
 */

import * as request from '@/utils/request'
const BASE_URL = 'v1'
export default {
  /**
   * createUser
   * @description 用户管理-新增
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createUser(data) {
    return request.post(`${BASE_URL}/user/store`,data)
  },

  /**
   * updateUser
   * @description 用户管理-编辑
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateUser(id, data){
    return request.put(`${BASE_URL}/user/update/${id}`, data)
  },

  /**
   * getUserList
   * @description 用户管理-列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getUserList(data) {
    return request.get(`${BASE_URL}/user/list`, data)
  },

  /**
   * viewaUser
   * @description 用户管理-详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  viewUser(data){
    return request.get(`${BASE_URL}/user/view/${data}`)
  },

  /**
   * deleteUser
   * @description 删除用户
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  deleteUser(data) {
    return request.Delete(`${BASE_URL}/user/delete/${data}`)
  },

  /**
   * getRolesList
   * @description 角色列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getRolesList() {
    return request.get(`${BASE_URL}/roles/list`)
  },

  /**
   * changeMobile
   * @description 修改手机号
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  changeMobile(id, data) {
    return request.put(`${BASE_URL}/user/change_mobile/${id}`, data)
  },

  /**
   * changePassword
   * @description 修改密码
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  changePassword(id, data) {
    return request.put(`${BASE_URL}/user/changePassword/${id}`, data)
  },

  /**
   * getUserCompanyList
   * @description 获取用户的公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getUserCompanyList() {
    return request.get(`${BASE_URL}/user/company_list`, null)
  },

  /**
   * bindCompany
   * @description 公司绑定
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  bindCompany(id, data) {
    return request.put(`${BASE_URL}/user/bind_company/${id}`, data)
  }







  // getUserList(data) {
  //   return request.post('/user/list',data)
  // },
  // saveUser(data) {
  //   return request.post('/user/store',data)
  // },
  // getUserInfo(id) {
  //   let data = {id:id}
  //   return request.post('/user/get_info',data)
  // },
  // deleteUser(id) {
  //   let data = {id:id}
  //   return request.post('/user/delete',data)
  // },
  // getUserRoles() {
  //   return request.post('/user/get_roles')
  // },
  // userSwitch(company_id, settlement_id) {
  //   let data = {
  //     company_id: company_id,
  //     settlement_id: settlement_id,
  //   }
  //   return request.post('/user/switch', data)
  // },
  // getUserProfile() {
  //   return request.get('/user/profile')
  // },
  // setUserProfile(data) {
  //   return request.post('/user/profile', data)
  // },
  // getUserCompany() {
  //   return request.get('/user/get_company')
  // },
  // getUserSettlement(data) {
  //   return request.get('/user/get_settlement', data)
  // },
  // changeWarning(data) {
  //   return request.post('/user/change_warning', data)
  // }
}